var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$q.screen.gt.xs ? 'q-pa-xl' : 'q-pa-sm'},[_c('h1',{staticClass:"text-h5 q-pb-md q-my-md text-left fields-tab-header"},[_vm._v(" Manage datasets ")]),_c('div',[(_vm.customer_groups_ready)?_c('CustomerGroupList'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }